
import Vue from 'vue';
// @ts-ignore
import { v4 as uuidv4 } from 'uuid';
import Router, { Route } from 'vue-router';
import RouteUtils from '@/utils/route-utils';
import { pageService as uiCorePageService, siteConfigService as uiCoreSiteConfigService, SiteInfo as UiCoreSiteInfo, userService } from '@ol/ol-ui-core';
import BackToOriginUtils from '@/utils/back-to-origin-utils';
import routerHelper from './router-helper';
import storageService from './services/storage.service';
import { PageAttributeType } from './entities/page.attributes';
import { PLBoxInstanceAttribute } from './entities/contactus/submit-contact-us-ent';
import plBoxInstanceService from './services/pl.box.instance.service';


Vue.use(Router);
class RouterFactory {
  static getRouter() {
    const config: any =
    {
      base: process.env.BASE_URL,
      routes: [
        {
          path: '/',
          name: 'loginPage',
          component: async () => routerHelper.getRouteComponent('loginPage'),
          meta: { title: { key: 'login.page.title', default: 'Login Page' }, olTrackingPage: 'login' },

        },
        {
          path: '/redirect',
          name: 'redirect',
          component: async () => routerHelper.getRouteComponent('redirect'),
          meta: { title: { key: 'Redirect', default: 'Redirect' }, olTrackingPage: '' },

        },
        {
          path: '/orgSelect',
          name: 'orgSelectPage',
          component: async () => routerHelper.getRouteComponent('orgSelectPage'),
          meta: { title: { key: 'select.org.page.title', default: 'Organization Select Page' }, olTrackingPage: 'org-selection' },
        },
        {
          path: '/lesseeSignature',
          name: 'lesseeSignaturePage',
          component: async () => routerHelper.getRouteComponent('lesseeSignaturePage'),
          meta: { title: { key: 'lessee.signature.page.title', default: 'Lessee Signature Page' }, olTrackingPage: 'lessee-signature' },
        },
        {
          path: '/testPage',
          name: 'testPage',
          component: async () => routerHelper.getRouteComponent('testPage'),
          meta: { title: { key: 'test.page.title', default: 'Test Page' }, olTrackingPage: 'test' },
        },
        {
          path: '/clearLocalStorageRedirectToLogoutPage',
          name: 'clearLocalStorageRedirectToLogoutPage',
          component: async () => routerHelper.getRouteComponent('clearLocalStorageRedirectToLogoutPage'),
          meta: { title: { key: 'clear.local.storage.redirect.to.logout.page.title', default: 'Clear Local Storage And Redirect To Logout Page' }, olTrackingPage: 'clearLocalStorageRedirectToLogoutPage' },
        },
        {
          path: '/awaitingPricing',
          name: 'awaitingPricingPage',
          component: async () => routerHelper.getRouteComponent('awaitingPricingPage'),
          meta: { title: { key: 'awaiting.pricing.page.title', default: 'Awaiting Pricing page' }, olTrackingPage: 'awaiting-pricing' },
        },
        {
          path: '/transactionTransportReport',
          name: 'transactionTransportPage',
          component: async () => routerHelper.getRouteComponent('transactionTransportPage'),
          meta: { title: { key: 'transaction.transport.page.title', default: 'Transaction Transport page' }, olTrackingPage: 'transaction-transport' },
        },
        {
          path: '/homePage',
          redirect: '/page/HOME_PAGE',
        },
        {
          path: '/page/:pageCode',
          name: 'dynamicalPage',
          component: async () => routerHelper.getRouteComponent('pageTemplateRenderWidgetInvocation'),
          meta: { title: { key: 'dynamical.page.title', default: '' }, olTrackingPage: 'dynamical-page' },
        },
        {
          path: '/termsOfTradePage',
          name: 'termsOfTradePage',
          component: async () => routerHelper.getRouteComponent('termsOfTradePage'),
          meta: { title: { key: 'termsOfTrade.title', default: 'TermsOfTrade Page ' }, olTrackingPage: 'term-of-trade' },
        },
        {
          path: '/turnIn',
          name: 'turnInPage',
          component: async () => routerHelper.getRouteComponent('turnInPage'),
          meta: { title: { key: 'turnIn.page.title', default: 'Turn In Page' }, olTrackingPage: 'turn-in' },
        },
        {
          path: '/turnIn/route',
          name: 'turnInRoutedPage',
          component: async () => routerHelper.getRouteComponent('turnInRoutedPage'),
          meta: { title: { key: 'turnIn.page.title', default: 'Turn In Page' }, olTrackingPage: 'turn-in' },
        },
        {
          path: '/turnIn/:subRoute',
          name: 'turnInSubRoute',
          props: true,
          component: async () => routerHelper.getRouteComponent('turnInSubRouteWrapper'),
          meta: { title: { key: 'turnIn.page.title', default: 'Turn In Page' }, olTrackingPage: 'turn-in' },
        },
        {
          path: '/audiCertifiedExcellence',
          name: 'audiCertifiedExecellencePage',
          component: async () => routerHelper.getRouteComponent('incentiveProgram'),
          meta: { title: { key: 'ace.page.title', default: 'Audi Certified Excellence' }, olTrackingPage: 'certified-excellence' },
        },
        {
          path: '/volkswagenAffinity',
          name: 'volkswagenAffinityPage',
          component: async () => routerHelper.getRouteComponent('incentiveProgram'),
          meta: { title: { key: 'vw.affinity.title', default: 'Volkswagen Affinity' }, olTrackingPage: 'affinity' },
        },
        {
          path: '/pendedGroundingVehicles',
          name: 'pendedGroundingVehicles',
          component: async () => routerHelper.getRouteComponent('pendedGroundingVehicles'),
          meta: { title: { key: 'pended.vehicles.title', default: 'Pended Vehicles' }, olTrackingPage: 'pended-vehicles' },
        },
        {
          path: '/activityReport',
          name: 'activityReportPage',
          component: async () => routerHelper.getRouteComponent('activityReportPage'),
          meta: { title: { key: 'activity.report.page.title', default: 'Dealer Activity Page' }, olTrackingPage: 'dealer-activity' },
        },
        {
          path: '/preLoginUsers',
          name: 'addDeleteUsersPreLoginPage',
          component: async () => routerHelper.getRouteComponent('addDeleteUsersPreLoginPage'),
          meta: { title: { key: 'activity.report.page.title', default: 'Add/Delete UsersPreLoginPage' }, olTrackingPage: 'add-delete-user-pre-login' },
        },
        {
          path: '/contactUs',
          name: 'contactUsPage',
          component: async () => routerHelper.getRouteComponent('contactUsPage'),
          meta: { title: { key: 'contactUs.page.title', default: 'ContactUs Page' }, olTrackingPage: 'contact-us' },
        },
        {
          path: '/contactUsBeforeLogin',
          redirect: '/page/CONTACT_US',
        },
        {
          path: '/scheduledTurnIn',
          name: 'scheduledTurnInPage',
          component: async () => routerHelper.getRouteComponent('scheduledTurnInPage'),
          meta: { title: { key: 'scheduled.turnIn.us.page.title\'', default: 'Scheduled TurnIn Page' }, olTrackingPage: 'scheduled-turn-in' },
        },
        {
          path: '/mbpoCalculator',
          name: 'mbpoCalculatorPage',
          component: async () => routerHelper.getRouteComponent('mbpoCalculatorPage'),
          meta: { title: { key: 'honda.mbpo.calculator.title', default: 'MBPO Calculator Page' }, olTrackingPage: 'mbpo-calculator' },
        },
        {
          path: '/calendar',
          name: 'calendarAuctionPage',
          component: async () => routerHelper.getRouteComponent('calendarAuctionPage'),
          meta: { title: { key: 'honda.calendar.auction.title', default: 'Calendar Auction Page' }, olTrackingPage: 'calendar-auction' },
        },
        {
          path: '/auctionLanding',
          name: 'auctionLanding',
          component: async () => routerHelper.getRouteComponent('auctionLandingPage'),
          meta: { title: { key: 'auctionLandingPage.us.page.title\'', default: 'Auction Landing Page' }, olTrackingPage: 'auction-landing' },
        },
        {
          path: '/chaseBuyBack',
          name: 'chaseBuyBack',
          component: async () => routerHelper.getRouteComponent('chaseBuyBackView'),
          meta: { title: { key: 'chase.buy.back.title', default: 'Buy-Back' }, olTrackingPage: 'buy-back' },
        },
        {
          path: '/makeOfferPage',
          name: 'makeOfferPage',
          component: async () => routerHelper.getRouteComponent('makeOfferPage'),
          meta: { title: { key: 'make.offer.page.title', default: 'Make an Offer Page' }, olTrackingPage: 'make-an-offer' },
        },
        {
          path: '/marketGuidePage',
          name: 'marketGuidePage',
          component: async () => routerHelper.getRouteComponent('marketGuidePage'),
          meta: { title: { key: 'market.guide.page.title', default: 'Market Guide' }, olTrackingPage: 'market-guide-page' },
        },
        {
          path: '/buyoutQuoteCalculator',
          name: 'buyoutQuoteCalculatorPage',
          component: async () => routerHelper.getRouteComponent('buyoutQuoteCalculatorPage'),
          meta: { title: { key: 'turnIn.page.title', default: 'Buyout Quote Calculator' }, olTrackingPage: 'buyout-quote-calculator' },
        },
        {
          path: '/siteAnnouncements',
          name: 'siteAnnouncementsPage',
          component: async () => routerHelper.getRouteComponent('siteAnnouncementsPage'),
          meta: { title: { key: 'announcement.title', default: 'Announcements' }, olTrackingPage: 'site-announcements' },
        },
        {
          path: '/maturityViewer',
          alias: '/maturitySearchResult',
          name: 'maturityViewerPage',
          component: async () => routerHelper.getRouteComponent('maturityViewerPage'),
          meta: { title: { key: 'maturityViewerPage.title', default: 'Maturity Viewer' }, olTrackingPage: 'maturity-search' },
        },
        {
          path: '/maturityLoanViewer',
          alias: '/maturityLoanSearchResult',
          name: 'maturityLoanViewerPage',
          component: async () => routerHelper.getRouteComponent('maturityLoanViewerPage'),
          meta: { title: { key: 'maturityLoanViewerPage.title', default: 'Maturity Loan Viewer' }, olTrackingPage: 'maturity-loan-search' },
        },
        {
          path: '/iosReg',
          name: 'iosRegisterFormPage',
          component: async () => routerHelper.getRouteComponent('iosRegisterFormPage'),
          meta: { title: { key: 'ios.register.form.title', default: 'IOS Register Form' }, olTrackingPage: 'ios-register-form' },
        },
        {
          path: '/payoffQuote',
          name: 'payoffQuotePage',
          component: async () => routerHelper.getRouteComponent('payoffQuotePage'),
          meta: { title: { key: 'payoffQuotePage.title', default: 'PayoffQuote Page' }, olTrackingPage: 'pay-off-quote' },
        },
        {
          path: '/loginMessage',
          name: 'loginMessagePage',
          component: async () => routerHelper.getRouteComponent('loginMessagePage'),
          meta: { title: { key: 'loginMessagePage.title', default: 'Login Message' }, olTrackingPage: 'login-message' },
        },
        {
          path: '/documents',
          name: 'showPdfPage',
          component: async () => routerHelper.getRouteComponent('showPDF'),
          meta: { title: { key: 'showPDF.title', default: 'PDF View Page ' }, olTrackingPage: 'pdf-view' },
        },
        {
          path: '/myAccount',
          name: 'My Account',
          component: async () => routerHelper.getRouteComponent('myAccount'),
          meta: { title: { key: 'my.account.doc.title', default: 'My Account' }, olTrackingPage: 'my-account' },
        },
        {
          path: '/pullAhead',
          name: 'pullAheadPage',
          component: async () => routerHelper.getRouteComponent('pullAheadPage'),
          meta: { title: { key: 'pullAheadPage.title', default: 'Pull Ahead' }, olTrackingPage: 'pull-ahead' },
        },
        {
          path: '/missedOpportunities',
          name: 'missedOpportunitiesPage',
          component: async () => routerHelper.getRouteComponent('missedOpportunitiesPage'),
          meta: { title: { key: 'missedOpportunitiesPage.title', default: 'Missed Opportunities' }, olTrackingPage: 'missed-opportunities' },
        },
        {
          path: '/myAccountSiteNotification',
          name: 'myAccountSiteNotification',
          component: async () => routerHelper.getRouteComponent('myAccountSiteNotification'),
          meta: { title: { key: 'myAccountSiteNotification.title', default: 'MyAccount SiteNotification' }, olTrackingPage: 'my-account-site-notification' },
        },
        {
          path: '/turnInSuccess',
          name: 'turnInSuccessPage',
          component: async () => routerHelper.getRouteComponent('turnInSuccessPage'),
          meta: { title: { key: 'turnIn.page.title', default: 'Turn In Page' }, olTrackingPage: 'turn-in-success' },
        },
        {
          path: '/incentive',
          name: 'incentivePage',
          component: async () => routerHelper.getRouteComponent('incentivePage'),
          meta: { title: { key: 'incentive.program.status.title', default: 'Incentive Page' }, olTrackingPage: 'incentive' },
        },
        {
          path: '/myAccountUserInformation',
          name: 'myAccountUserInformation',
          component: async () => routerHelper.getRouteComponent('myAccountUserInformation'),
          meta: { title: { key: 'myAccountUserInformation.title', default: 'My Account - User Info' }, olTrackingPage: 'my-account-user-infos' },
        },
        {
          path: '/myTransactions',
          name: 'myTransactionsPage',
          component: async () => routerHelper.getRouteComponent('myTransactionsPage'),
          meta: { title: { key: 'myTransactions.title', default: 'My Transactions' }, olTrackingPage: 'my-transactions' },
        },
        {
          path: '/sidashboard',
          name: 'siDashBoardPage',
          component: async () => routerHelper.getRouteComponent('siDashBoardPage'),
          meta: { title: { key: 'siDashBoard.title', default: 'SI 2.0 DashBoard' }, olTrackingPage: 'si-dashboard' },
        },
        {
          path: '/forgotPassword',
          name: 'forgotPasswordPage',
          component: async () => routerHelper.getRouteComponent('forgotPasswordPage'),
          meta: { title: { key: 'ForgotPassword.title', default: 'Forgot Password' }, olTrackingPage: 'forgot-password' },
        },
        {
          path: '/sitePreferences',
          name: 'sitePreferencesPage',
          component: async () => routerHelper.getRouteComponent('sitePreferencesPage'),
          meta: { title: { key: 'SitePreferences.title', default: 'Site Preferences' }, olTrackingPage: 'site-Preferences' },
        },
        {
          path: '/sellerMbpoCalculator',
          name: 'sellerMbpoCalculatorPage',
          component: async () => routerHelper.getRouteComponent('sellerMbpoCalculatorPage'),
          meta: { title: { key: 'seller.mbpo.calculator.title', default: 'Seller MBPO Calculator' }, olTrackingPage: 'seller-mbpo-calculator' },
        },
        {
          path: '/vdp',
          name: 'conditionReportVDP',
          component: async () => routerHelper.getRouteComponent('conditionReportVDP'),
          meta: { title: { key: 'condition.report.vdp', default: 'Condition Report on VDP' }, olTrackingPage: 'condition-report-on-vdp', pageCode: 'VDP' },
        },
        {
          path: '/vdpRedirect',
          name: 'vdpRedirect',
          component: async () => routerHelper.getRouteComponent('vdpRedirect'),
          meta: { title: { key: 'vdp.redirect', default: 'VDP Redirect' }, olTrackingPage: 'vdp-redirect' },
        },
        {
          path: '/userAgreement',
          name: 'userAgreementPage',
          component: async () => routerHelper.getRouteComponent('userAgreementPage'),
          meta: { title: { key: 'user.agreement.page.title', default: 'User Agreement' }, olTrackingPage: 'user-agreement' },
        },
        {
          path: '/incentiveConfigTool',
          name: 'incentiveConfigTool',
          component: async () => routerHelper.getRouteComponent('incentiveConfigToolPage'),
          meta: { title: { key: 'incentive.config.tool.title', default: 'incentive-config-tool' }, olTrackingPage: 'incentive-config-tool' },
        },
        {
          path: '/viewSummary',
          name: 'viewSummary',
          component: async () => routerHelper.getRouteComponent('viewSummaryPage'),
          meta: { title: { key: 'incentive.config.tool.title', default: 'incentive-config-tool' }, olTrackingPage: 'incentive-config-tool' },
        },
        {
          path: '/updateTemplateLocally',
          name: 'updateTemplateLocally',
          component: async () => routerHelper.getRouteComponent('updateTemplateLocally'),
          meta: { title: { key: 'UpdateTemplateLocally', default: 'UpdateTemplateLocally' }, olTrackingPage: '' },
        },
        {
          path: '/reg',
          name: 'olRegistrationFormPage',
          component: async () => routerHelper.getRouteComponent('olRegistrationFormPage'),
          meta: { title: { key: 'ol-registration.form.page.title', default: 'OL Registration Form Page' }, olTrackingPage: 'ol-registration-form' },
          beforeEnter: async (to: Route, from: Route, next: Function) => {
            const plId: number = await storageService.getPrivateLabelId();
            const attribute: PLBoxInstanceAttribute = await plBoxInstanceService.getAttribute(plId, PageAttributeType.PAGE_ELEMENT_SECTION_CONFIG_TYPE, 'REDIRECT_REG_PAGE');
            if (attribute.value === '1') {
              window.location.href = process.env.VUE_APP_LOGIN_PAGE_URL || '/stdpl/home.html';
            } else {
              next();
            }
          },
        },
        {
          path: '/oktaProxy',
          name: 'oktaProxyPage',
          component: async () => routerHelper.getRouteComponent('oktaProxyPage'),
          meta: { title: { key: 'oktaProxy.page.title', default: 'OKTA Proxy Page' }, olTrackingPage: 'okta-proxy' },
        },
        // Important Note : Please create new path above this line..
        {
          path: '/*',
          name: 'errorPage404',
          component: async () => routerHelper.getRouteComponent('errorPage404'),
          meta: { title: { key: 'error.page.404', default: 'Error Page 404' }, olTrackingPage: 'errorPage404' },
        },
      ],
    };
    return new Router(config);
  }
}


const router = RouterFactory.getRouter();


router.afterEach((to: Route, from: Route) => {
  Vue.nextTick(async () => {
    const pageCode: string = RouteUtils.getParam(to, 'pageCode');
    document.body.setAttribute('ol-page-code', pageCode);

    const plId: number = await storageService.getPrivateLabelId();
    const orgId: number = await userService.getCurrentOrgId(plId);
    const ssoToken: string = await userService.getSsoToken(plId);
    const languageCode: string = await storageService.getLanguageCode();
    await uiCorePageService.initPage(plId, orgId, ssoToken, languageCode, pageCode);
    const trackingPageName: string = await uiCorePageService.getTrackingPageName(plId, orgId, ssoToken, languageCode, pageCode, to.meta.olTrackingPage);
    const pageTitle: string = await uiCorePageService.getPageTitle(plId, orgId, ssoToken, languageCode, pageCode, to.meta.title.key, to.meta.title.default);

    BackToOriginUtils.key = pageTitle;
    BackToOriginUtils.link = window.location.href;

    document.body.setAttribute('data-ol-trk-page-name', trackingPageName);
    document.body.setAttribute('data-ol-trk-page-uuid', uuidv4());

    const siteInfo: UiCoreSiteInfo = await uiCoreSiteConfigService.getSiteInfo(plId);
    if (siteInfo && siteInfo.privateLabelInfo && siteInfo.privateLabelInfo.name) {
      document.title = `${siteInfo.privateLabelInfo.name} - ${pageTitle}`;
    } else {
      document.title = pageTitle;
    }
  });
});


export default router;
